$(document).ready(function() {
    $(".c-product-slider").slick({
        autoplay: false,
        infinite: true,
        dots: true, 
        arrows: false, 
        customPaging: function(e, n) {
            var o = e.$slides[n].querySelector("[js-product-slider-thumbnail]").getAttribute("js-product-slider-thumbnail");
            return '<button class="c-product-slider__slider-dot"><img class="c-product-slider__slider-dot-image" src="' + o + '"></button>'
        },
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });

    $(".c-product-stats").slick({
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }]
    });
});